function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "15",
  height: "15",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#FFF",
  cx: "7.5",
  cy: "7.5",
  r: "7.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.5 0a7.5 7.5 0 110 15 7.5 7.5 0 010-15zm0 1a6.5 6.5 0 100 13 6.5 6.5 0 000-13zm.567 4.916V12H7.053V5.916h1.014zm-.507-3.12c.208 0 .383.074.526.221.144.147.215.32.215.52 0 .217-.07.394-.208.533a.722.722 0 01-.533.208.722.722 0 01-.533-.208.722.722 0 01-.208-.533c0-.2.071-.373.215-.52a.705.705 0 01.526-.221z",
  fill: "#4285F4"
}))));